// Global-search query input, shared by the desktop box, the mobile box and history replay.

// Letters and digits of any script (localized feature names such as "Grundriss", "Gerätetyp",
// "ファームウェア" or "目标固件" must be typable), combining marks, apostrophes (French "Plan d'étage"),
// and the separators that MAC, IP and serial-number searches use. Everything else is dropped.
const DISALLOWED_SEARCH_CHARACTERS = /[^\p{L}\p{M}\p{N}_\-. :'\u2019]/gu;

/** Drops disallowed characters and any leading spaces or dots. */
export const sanitizeSearchInput = (input) => {
  if (!input) return '';
  return String(input)
    .replace(DISALLOWED_SEARCH_CHARACTERS, '')
    .replace(/^[ .]+/, '');
};

/**
 * A MAC-looking query ("AA:BB:CC", "aa-bb-") is normalised to lowercase, '-'-separated form; anything
 * else, including text in any script, is only trimmed.
 */
export const normalizeMacSearchQuery = (input) => {
  const trimmed = input?.trim?.() || '';
  if (!trimmed) return trimmed;

  const hasMacSeparator = /[:-]/.test(trimmed);
  if (!hasMacSeparator) {
    return trimmed;
  }

  const macSegments = trimmed.split(/[:-]/);
  const endsWithSeparator = /[:-]$/.test(trimmed);
  const segmentsToValidate = endsWithSeparator ? macSegments.slice(0, -1) : macSegments;
  const hasValidSegmentCount = macSegments.length >= 2 && macSegments.length <= 6;
  const hasUnexpectedEmptySegment = segmentsToValidate.some((segment) => segment.length === 0);
  const hasOnlyHexSegments = segmentsToValidate.every((segment) => /^[A-Fa-f0-9]{1,2}$/.test(segment));
  const isMacLikeQuery = hasValidSegmentCount && segmentsToValidate.length > 0 && !hasUnexpectedEmptySegment && hasOnlyHexSegments;

  if (!isMacLikeQuery) {
    return trimmed;
  }

  const normalized = segmentsToValidate.join('-').toLowerCase();
  return endsWithSeparator ? `${normalized}-` : normalized;
};

/** History replay: the same character rules, then MAC normalisation. */
export const sanitizeHistorySearchInput = (input) => normalizeMacSearchQuery(sanitizeSearchInput(input));
